import { render, staticRenderFns } from "./InventoriesGeneralLayout.vue?vue&type=template&id=4f06e5c7"
import script from "./InventoriesGeneralLayout.vue?vue&type=script&lang=js"
export * from "./InventoriesGeneralLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports